<script lang="ts">
  import { PlusCircle } from "svelte-feathers"

  import { Milestone, addMilestone, LateRegistrantPaymentStrategy } from "@models/milestones/Milestone"
  export let milestones: Milestone[]
  export let tripId: number
  export let lateRegistrantPaymentStrategy: LateRegistrantPaymentStrategy = "catch_up"

  function addPayment() {
    milestones = addMilestone(milestones, tripId, lateRegistrantPaymentStrategy)
  }
</script>

<div class="row justify-end | block-11 | bg-gray-100 border-b">
  <span>
    <a
      data-role="add-milestone-button"
      class="legacy-with-icon svg-icon pad-inline-4 | block-6"
      href={"#"}
      on:click={addPayment}>
      <PlusCircle size="16" strokeWidth={2.5} />
      Add Another Payment
    </a>
  </span>
</div>
